<div class="empty" *ngIf="answers && !filteredPictures?.length">No pictures found using current filters.</div>

<div
  *ngIf="filteredPictures?.length > 0"
  class="grid-toolbar"
  style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; margin-top: 20px">
  <pagination
    class="pagination"
    [ngModel]="currentPage"
    [totalItems]="totalItems"
    [itemsPerPage]="pageSize"
    [maxSize]="7"
    [boundaryLinks]="true"
    [rotate]="false"
    (pageChanged)="setPage($event.page)">
  </pagination>

  <div class="toolbar-controls">
    <button type="button" class="btn btn-aru share-gallery-link-btn" (click)="openShareGalleryLinkModal()">
      <div class="icon-tooltip-wrapper">
        <img
          [src]="isGallerySharingEnabled() ? 'assets/img/svg/sharing.svg' : 'assets/img/svg/sharing-disabled.svg'"
          class="icon"
          alt="" />
        <span class="tooltip">
          {{ isGallerySharingEnabled() ? 'Gallery sharing active' : 'Gallery sharing disabled' }}
        </span>
      </div>
      Share Gallery Link
    </button>
    <div class="toolbar-control">
      <label>
        <input type="checkbox" [(ngModel)]="showLabels" />
        Show photo labels
      </label>
    </div>

    <div class="toolbar-control">
      <label>Items per page:</label>
      <select [(ngModel)]="pageSize" (change)="setPageSize(pageSize)">
        <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
      </select>
    </div>

    <div class="dual-monitor-icon" (click)="togglePopup()">
      <svg
        *ngIf="!popupActive"
        width="20"
        height="20"
        viewBox="0 0 26 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22 13H24V2H8V4H6V1.007C6 0.451 6.455 0 6.992 0H25.008C25.556 0 26 0.449 26 1.007V13.993C26 14.549 25.545 15 25.008 15H22V13Z"
          fill="#2763CD" />
        <path
          d="M2.00004 19H18V8H2.00004V19ZM11 21V23H15V25H5.00004V23H9.00004V21H0.992041C0.860727 20.9992 0.730858 20.9725 0.609879 20.9215C0.488899 20.8704 0.379188 20.7959 0.287032 20.7024C0.194877 20.6088 0.122089 20.498 0.0728414 20.3763C0.0235937 20.2546 -0.00114581 20.1243 4.07459e-05 19.993V7.007C4.07459e-05 6.451 0.455041 6 0.992041 6H19.008C19.556 6 20 6.449 20 7.007V19.993C20 20.549 19.545 21 19.008 21H11Z"
          fill="#2763CD" />
      </svg>
      <svg
        *ngIf="popupActive"
        width="20"
        height="20"
        viewBox="0 0 26 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22 13H24V2H8V4H6V1.007C6 0.451 6.455 0 6.992 0H25.008C25.556 0 26 0.449 26 1.007V13.993C26 14.549 25.545 15 25.008 15H22V13Z"
          fill="#2763CD" />
        <path
          d="M2.00004 19H18V8H2.00004V19ZM11 21V23H15V25H5.00004V23H9.00004V21H0.992041C0.860727 20.9992 0.730858 20.9725 0.609879 20.9215C0.488899 20.8704 0.379188 20.7959 0.287032 20.7024C0.194877 20.6088 0.122089 20.498 0.0728414 20.3763C0.0235937 20.2546 -0.00114581 20.1243 4.07459e-05 19.993V7.007C4.07459e-05 6.451 0.455041 6 0.992041 6H19.008C19.556 6 20 6.449 20 7.007V19.993C20 20.549 19.545 21 19.008 21H11Z"
          fill="#2763CD" />
        <rect
          x="8.00195"
          y="10.3418"
          width="7.53511"
          height="1.88378"
          transform="rotate(45 8.00195 10.3418)"
          fill="#2763CD" />
        <rect
          x="6.66992"
          y="15.6699"
          width="7.53511"
          height="1.88378"
          transform="rotate(-45 6.66992 15.6699)"
          fill="#2763CD" /></svg
      >&nbsp;
      <a>{{ !popupActive ? 'Activate' : 'Deactivate' }} dual-monitor</a>
    </div>

    <div class="view-toggle-buttons">
      <button type="button" [class.active]="gridSize === 'large'" (click)="gridSize = 'large'" title="Large grid">
        <i class="fa fa-th-large"></i>
      </button>

      <button type="button" [class.active]="gridSize === 'small'" (click)="gridSize = 'small'" title="Small grid">
        <i class="fa fa-th"></i>
      </button>
    </div>
  </div>
</div>

<div
  class="picture-grid"
  [ngClass]="{ 'show-labels': showLabels, large: gridSize == 'large', small: gridSize == 'small' }">
  <div class="picture-slot" *ngFor="let picture of pagedPictures">
    <div
      class="picture-aspect"
      [class.current-picture]="picture === currentPicture"
      [class.selected]="picture.selected">
      <!-- Selection checkbox in top left -->
      <div class="selection-overlay">
        <label class="checkbox-container" [class.visible]="picture.selected">
          <input
            type="checkbox"
            [checked]="picture.selected"
            [disabled]="picture.loading"
            (change)="toggleSelection(picture)" />
          <span class="checkmark"></span>
        </label>
      </div>

      <!-- Rotation buttons in top right -->
      <div class="picture-overlay">
        <button class="rotate-btn" [disabled]="!canRotate(picture)" (click)="rotate(picture)">&#8635;</button>
        <button class="rotate-btn" [disabled]="!canRotate(picture)" (click)="rotate(picture, -90)">&#8634;</button>
      </div>

      <!-- Show spinner when loading -->
      <div *ngIf="picture.loading" class="spinner-container">
        <div class="spinner"></div>
      </div>

      <!-- Show image when not loading -->
      <img
        *ngIf="!picture.loading && picture.imageUrl"
        [src]="picture.imageUrl"
        [alt]="picture.label"
        (click)="open(picture)" />

      <!-- Information overlay at the bottom -->
      <div class="info-overlay">
        <div class="picture-label" *ngIf="showLabels && picture.label" (click)="gotoQuestion(picture)">
          {{ picture.label }} <br />
          <span class="date">{{ picture.createdDate | date: 'MM/dd/yyyy h:mm a' }}</span>
        </div>
        <div class="info-wrapper">
          <div class="info-left">
            <span class="info-item">
              <i class="fa fa-comment"></i> {{ picture.answer?.comments?.length || 0 }} comments
            </span>
            <span class="info-item"> <i class="fa fa-flag"></i> {{ picture.answer?.flags?.length || 0 }} flags </span>
            <button *ngIf="!showLabels" class="question-btn" (click)="gotoQuestion(picture)" title="Go to question">
              <i class="fa fa-external-link"></i>
            </button>
          </div>
          <div class="info-right">
            <span class="date">{{ picture.createdDate | date: 'MM/dd/yyyy h:mm a' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<br />

<pagination
  *ngIf="filteredPictures?.length > 0"
  class="pagination"
  [ngModel]="currentPage"
  [totalItems]="totalItems"
  [itemsPerPage]="pageSize"
  [maxSize]="7"
  [boundaryLinks]="true"
  [rotate]="false"
  (pageChanged)="setPage($event.page)"
  style="margin-left: 145px">
</pagination>

<div class="bottom-sheet" *ngIf="selectedPictures?.length">
  <span>
    <span>Images selected: {{ selectedPictures.length }}</span>
    <button class="btn btn-sm btn-link" (click)="checkAll()">Select all</button>
    <span>/</span>
    <button class="btn btn-sm btn-link" (click)="uncheckAll()">Deselect all</button></span
  >
  <span>
    <button class="rotate-btn tooltip-container" data-tooltip="Rotate clockwise" (click)="rotateSelected()">
      &#8635;
    </button>
    <button class="rotate-btn tooltip-container" data-tooltip="Rotate counter-clockwise" (click)="rotateSelected(-90)">
      &#8634;
    </button>
  </span>
  <span>
    <label style="margin-right: 15px">
      <input type="checkbox" [(ngModel)]="includeMarkup" />
      Include Flags/Markup
    </label>
    <button class="btn btn-primary" (click)="downloadSelected()">Download</button>
  </span>
</div>

<div
  *ngIf="fullscreen && !popupActive"
  style="
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    z-index: 1020;
    display: flex;
  ">
  <div style="overflow: auto; position: relative; flex-direction: column; flex: 1">
    <app-picture-viewer
      #pictureViewer
      [picture]="currentPicture"
      [flags]="getFlags(currentPicture)"
      [placeholderFlag]="flagPlaceholder"
      [updateImage]="updateImage"
      (moveFlag)="moveFlag($event)"
      (addFlag)="addFlag($event)"
      (editFlag)="editFlag($event)"
      (markupChanged)="updatePicture()"
      (changeFullscreen)="exitFullscreen()"
      [isFullscreen]="fullscreen">
    </app-picture-viewer>

    <i
      (click)="exitFullscreen()"
      class="fa fa-arrow-left"
      style="
        text-shadow: 0px 0px 3px #000;
        color: #fff;
        cursor: pointer;
        position: absolute;
        top: 15px;
        left: 65px;
        font-size: 25px;
        z-index: 400;
      "></i>

    <div class="flag-panel">
      <a
        class="notification-flags"
        (click)="unpinnedFlagCount(currentPicture) !== 0 && toggleUnpinnedFlags()"
        [class.disabled-link]="unpinnedFlagCount(currentPicture) === 0">
        <i class="fa fa-flag fa-1x icon-styling" [class.disabled-icon]="unpinnedFlagCount(currentPicture) === 0"></i>
        <span *ngIf="unpinnedFlagCount(currentPicture) > 0" class="badge">{{ unpinnedFlagCount(currentPicture) }}</span>
      </a>
    </div>

    <div *ngIf="filteredPictures?.length > 1">
      <i
        *ngIf="hasPrev"
        (click)="prev()"
        class="fa fa-chevron-left"
        style="
          font-size: 30px;
          position: absolute;
          color: white;
          top: 45%;
          cursor: pointer;
          padding: 10px;
          z-index: 400;
          margin-left: 10px;
        "></i>

      <i
        *ngIf="hasNext"
        (click)="next()"
        class="fa fa-chevron-right"
        style="
          font-size: 30px;
          position: absolute;
          color: white;
          top: 45%;
          right: 20px;
          cursor: pointer;
          padding: 10px;
          z-index: 400;
        "></i>
    </div>

    <div class="bottom-info">
      {{ currentPicture?.createdDate | date: 'MM/dd/yyyy h:mm a' }} &nbsp; | &nbsp; Flags:
      {{ currentPicture?.answer?.flags?.length }} <br />
      <a
        style="
          display: block;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 80%;
          white-space: nowrap;
          color: white;
        "
        [routerLink]="'/inspection/review/main/' + inspection?.id"
        [queryParams]="getLinkParams(filteredPictures[current])"
        queryParamsHandling="merge"
        >{{ currentPicture?.label }}</a
      >
    </div>
  </div>
  <div id="right-column" *ngIf="showUnpinnedFlags">
    <app-unpinned-flags [picture]="currentPicture" (flagPinned)="pinFlag($event)" (close)="toggleUnpinnedFlags()">
    </app-unpinned-flags>
  </div>
</div>

<app-add-flag #addFlagModal></app-add-flag>
<app-edit-flag #editFlagModal></app-edit-flag>

<app-inspection-share-gallery-modal
  #shareGalleryLinkModal
  [inspection]="inspection"
  (inspectionUpdated)="inspection = $event"></app-inspection-share-gallery-modal>
